import { render, staticRenderFns } from "./CreateEditClientModal.vue?vue&type=template&id=51d38080&"
import script from "./CreateEditClientModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports